export default "<div #iconElement class=\"icon\"></div>";